<div class="container-fluid mt-4">
  <div class="p-1">
    <app-upload
      (uploadComplete)="onUploadComplete()"
      [uploadPath]="normalizedCurrentPath">
    </app-upload>
  </div>

  <div class="alert alert-secondary mb-3 mt-3">
    <strong>მიმდინარე გზა:</strong> {{ normalizedCurrentPath || '/' }}
  </div>

  <div class="d-flex align-items-center gap-2 mb-3 flex-wrap">
    <div *ngIf="pathStack.length > 0">
      <button (click)="goBack()" class="btn btn-light border">
        <i class="fi fi-rr-left"></i> უკან დაბრუნება
      </button>
    </div>

    <app-folder-create
      [currentPath]="normalizedCurrentPath"
      (folderCreated)="onUploadComplete()">
    </app-folder-create>
  </div>

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <div class="file-grid" *ngIf="!load">
    <div *ngFor="let item of fileTree; trackBy: trackByPath" class="file-card">

      <!-- folder -->
      <ng-container *ngIf="item.type === 'folder'; else fileBlock">
        <div class="file-card__inner folder-card" (click)="openFolder(item)">
          <div class="thumb thumb--folder">
            <i class="fi fi-rr-folder"></i>
          </div>

          <div class="name" [title]="item.name">{{ item.name }}</div>

          <div class="bottom-actions" (click)="$event.stopPropagation()">
            <button type="button" (click)="openFolder(item)" title="გახსნა">
              <i class="fi fi-rr-folder-open"></i>
            </button>

            <button type="button" (click)="openEdit(item)" title="სახელის შეცვლა">
              <i class="fi fi-rr-edit"></i>
            </button>

            <button type="button" (click)="delete(item)" title="წაშლა">
              <i class="fi fi-rr-trash"></i>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- file -->
      <ng-template #fileBlock>
        <div class="file-card__inner">
          <div
            class="thumb"
            (click)="multiselect ? selectMultipleFile(item.url) : selectFile(item.url)">

            <img
              *ngIf="isImageFile(item.name); else documentThumb"
              [src]="item.url"
              [alt]="item.name"
              loading="lazy"
              decoding="async"
              [class.selected]="selectedFiles.includes(item.url)" />

            <ng-template #documentThumb>
              <div class="file-icon">
                <i [class]="getFileIcon(item.name)"></i>
              </div>
            </ng-template>
          </div>

          <div class="name" [title]="item.name">{{ item.name }}</div>

          <div class="bottom-actions" (click)="$event.stopPropagation()">
            <button type="button" (click)="openInNewTab(item)" title="ახალ ფანჯარაში გახსნა">
              <i class="fi fi-rr-link-alt"></i>
            </button>

            <button type="button" (click)="copyLink(item)" title="ლინკის კოპირება">
              <i class="fi fi-rr-copy"></i>
            </button>

            <button type="button" (click)="openEdit(item)" title="სახელის შეცვლა">
              <i class="fi fi-rr-edit"></i>
            </button>

            <button type="button" (click)="delete(item)" title="წაშლა">
              <i class="fi fi-rr-trash"></i>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>


<app-file-edit
  *ngIf="editingFile"
  [file]="editingFile"
  (updated)="onUploadComplete()"
  (closed)="editingFile = null">
</app-file-edit>